import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import { LinearProgress, CircularProgress, Typography, Box } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  central: { textAlign: 'center' },
  linear: { height: '6px' },
  loader: {
    alignItems: 'center',
    display: 'flex',
    height: '100vh',
    justifyContent: 'center',
  },
  root: { width: '100%' },
}))

function LoadingScreen() {
  const classes = useStyles()
  const { t } = useTranslation('common')
  return (

    <div className={classes.root}>
      <LinearProgress className={classes.linear} />
      <Box className={classes.loader}>
        <Box className={classes.central}>
          <CircularProgress thickness={5} />
          <Typography>{t('common.loading')}</Typography>
        </Box>
      </Box>
    </div>

  )
}

export default LoadingScreen
